const inputFields = [
  {
    name: "language",
    type: "dynamic_select",
    label: "Select Language",
    placeholder: "",
    options: [],
  },
  {
    name: "title",
    type: "text ",
    label: "Title",
  },
  {
    name: "slug",
    type: "text",
    label: "Path",
  },

  {
    name: "content",
    type: "ckeditor",
    label: "Content",
    placeholder: "",
  },
];

export default inputFields;
